'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rxjs = require('rxjs');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _utilsMath = require('@bibliocommons/utils-math');

var _utilsEvent = require('@bibliocommons/utils-event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MIN_SCALE = 1;

function isZoomed(scale) {
  return scale > 1;
}

/**
 *
 * Usage:
 *    <PinchHandler scale={1} x={0} y={0} onUpdate={({ x y, scale }) => this.setState({ x, y, scale })}>
 *      <img src="" style={{}} />
 *    </PinchHandler>
 */

var PinchHandler = function (_BcReactComponent) {
  _inherits(PinchHandler, _BcReactComponent);

  function PinchHandler(props) {
    _classCallCheck(this, PinchHandler);

    var _this = _possibleConstructorReturn(this, (PinchHandler.__proto__ || Object.getPrototypeOf(PinchHandler)).call(this, props));

    _this.state = {
      isPinching: false,
      isPanning: false
    };
    return _this;
  }

  _createClass(PinchHandler, [{
    key: 'resize',
    value: function resize() {
      if (this._root) {
        var domNode = this._root;
        this.setState({
          size: {
            width: domNode.offsetWidth,
            height: domNode.offsetHeight
          }
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handlePinch();
      this.handlePanWithKeyboard();
      this.handleWheel();
      this.resize();
      this.resize$ = _rxjs.Observable.fromEvent(window, 'resize').throttleTime(500).subscribe(this.resize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      var observables = ['pinch', 'resize', 'wheel', 'keyboard'];

      observables.forEach(function (observableName) {
        var obsv$ = _this2[observableName + '$'];
        if (obsv$) {
          obsv$.unsubscribe();
          _this2[observableName + '$'] = null;
        }
      });

      this._root = null;
    }
  }, {
    key: 'handleWheel',
    value: function handleWheel() {
      var _this3 = this;

      var domNode = this._root;
      var wheel$ = _rxjs.Observable.fromEvent(domNode, 'wheel').map(function (e) {
        var _props = _this3.props,
            scale = _props.scale,
            maxScale = _props.maxScale;


        if (e.ctrlKey) {
          e.preventDefault();
          var mod = Math.exp(-e.deltaY / 100);

          return (0, _utilsMath.between)(MIN_SCALE, maxScale, mod * scale);
        }

        return scale;
      });

      this.wheel$ = wheel$.subscribe(function (newScale) {
        var _props2 = _this3.props,
            scale = _props2.scale,
            x = _props2.x,
            y = _props2.y,
            onUpdate = _props2.onUpdate;

        if (scale !== newScale) {
          onUpdate({
            scale: newScale,
            x: scale === MIN_SCALE ? 0 : x,
            y: scale === MIN_SCALE ? 0 : y
          });
        }
      });
    }
  }, {
    key: 'handlePanWithKeyboard',
    value: function handlePanWithKeyboard() {
      var _this4 = this;

      var domNode = this._root;
      var keydown$ = _rxjs.Observable.fromEvent(domNode, 'keydown').filter(_utilsEvent.isArrowKey).map(function (e) {
        e.preventDefault();

        var _props3 = _this4.props,
            scale = _props3.scale,
            x = _props3.x,
            y = _props3.y;
        var size = _this4.state.size;

        var movement = (0, _utilsEvent.getKeyCodeMovement)(e).map(function (val) {
          return val * 25;
        });

        var _movement = _slicedToArray(movement, 2),
            xDelta = _movement[0],
            yDelta = _movement[1];

        var scaleFactorX = (size.width * scale - size.width) / (scale * 2);
        var scaleFactorY = (size.height * scale - size.height) / (scale * 2);
        return {
          x: (0, _utilsMath.between)((0, _utilsMath.inverse)(scaleFactorX), scaleFactorX, x + xDelta),
          y: (0, _utilsMath.between)((0, _utilsMath.inverse)(scaleFactorY), scaleFactorY, y + yDelta),
          scale: scale
        };
      });

      this.keyboard$ = keydown$.subscribe(this.props.onUpdate);
    }
  }, {
    key: 'handlePinch',
    value: function handlePinch() {
      var _this5 = this;

      var domNode = this._root;
      var touchStart = _rxjs.Observable.merge(_rxjs.Observable.fromEvent(domNode, 'touchstart'), _rxjs.Observable.fromEvent(domNode, 'mousedown'));
      var touchMove = _rxjs.Observable.merge(_rxjs.Observable.fromEvent(document, 'touchmove'), _rxjs.Observable.fromEvent(document, 'mousemove'));
      var touchEnd = _rxjs.Observable.merge(_rxjs.Observable.fromEvent(document, 'touchend'), _rxjs.Observable.fromEvent(document, 'mouseup'));

      var translatePos = function translatePos(point, size) {
        return {
          x: point.x - size.width / 2,
          y: point.y - size.height / 2
        };
      };

      var pinch$ = touchStart.do(function (event) {
        var scale = _this5.props.scale;
        if ((0, _utilsEvent.hasTwoTouchPoints)(event) || isZoomed(scale)) {
          event.preventDefault();
        }
      }).mergeMap(function (md) {
        var startPoint = (0, _utilsEvent.normalizeTouch)(md);
        var size = _this5.state.size;


        return touchMove.map(function (mm) {
          var _props4 = _this5.props,
              scale = _props4.scale,
              x = _props4.x,
              y = _props4.y,
              maxScale = _props4.maxScale;

          var movePoint = (0, _utilsEvent.normalizeTouch)(mm);

          if ((0, _utilsEvent.hasTwoTouchPoints)(mm)) {
            var scaleFactor = 0;
            if ((0, _utilsEvent.isTouchEvent)(mm) && mm.scale) {
              scaleFactor = mm.scale;
            } else if (movePoint.x < size.width / 2) {
              scaleFactor = scale + (translatePos(startPoint, size).x - translatePos(movePoint, size).x) / size.width;
            } else {
              scaleFactor = scale + (translatePos(movePoint, size).x - translatePos(startPoint, size).x) / size.width;
            }

            var nextScale = (0, _utilsMath.between)(1, maxScale, scaleFactor);
            return {
              scale: nextScale,
              x: nextScale < 1.01 ? 0 : x,
              y: nextScale < 1.01 ? 0 : y
            };
          }

          var scaleFactorX = (size.width * scale - size.width) / (maxScale * 2);
          var scaleFactorY = (size.height * scale - size.height) / (maxScale * 2);
          return {
            x: (0, _utilsMath.between)((0, _utilsMath.inverse)(scaleFactorX), scaleFactorX, movePoint.x - startPoint.x),
            y: (0, _utilsMath.between)((0, _utilsMath.inverse)(scaleFactorY), scaleFactorY, movePoint.y - startPoint.y)
          };
        }).takeUntil(touchEnd);
      });

      this.pinch$ = pinch$.subscribe(function (newObject) {
        if (_this5.props.scale !== newObject.scale) {
          _this5.refreshPinchTimeoutTimer();
        }
        window.requestAnimationFrame(function () {
          _this5.props.onUpdate(_extends({
            x: _this5.props.x,
            y: _this5.props.y,
            scale: _this5.props.scale
          }, newObject));
        });
      });
    }
  }, {
    key: 'refreshPinchTimeoutTimer',
    value: function refreshPinchTimeoutTimer() {
      var _this6 = this;

      if (this.pinchTimeoutTimer) {
        clearTimeout(this.pinchTimeoutTimer);
      }

      if (!this.state.isPinching) {
        this.pinchStarted();
      }

      this.pinchTimeoutTimer = setTimeout(function () {
        return _this6.pinchStopped();
      }, 500);
    }
  }, {
    key: 'pinchStarted',
    value: function pinchStarted() {
      this.setState({
        isPinching: true
      }, this.props.onPinchStart);
    }
  }, {
    key: 'pinchStopped',
    value: function pinchStopped() {
      this.setState({
        isPinching: false
      }, this.props.onPinchStop);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      return _react2.default.createElement(
        'div',
        { ref: function ref(el) {
            _this7._root = el;
          } },
        this.props.children
      );
    }
  }]);

  return PinchHandler;
}(_baseBcReactComponent2.default);

exports.default = PinchHandler;


PinchHandler.defaultProps = {
  scale: 1,
  maxScale: 2,
  x: 0,
  y: 0,
  onPinchStart: function onPinchStart(f) {
    return f;
  },
  onPinchStop: function onPinchStop(f) {
    return f;
  }
};

PinchHandler.propTypes = {
  onPinchStart: _react.PropTypes.func,
  onPinchStop: _react.PropTypes.func,
  initialScale: _react.PropTypes.number,
  scale: _react.PropTypes.number,
  x: _react.PropTypes.number,
  y: _react.PropTypes.number
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-pan-zoom/lib/components/pinch-handler/components/PinchHandler.component.js
// module id = 1337
// module chunks = 1